import { gql } from "@apollo/client";
import { TerminalTypesInfo } from "./getTerminalTypesCall";

export const PANEL_CREATE_SECTION = gql`
  mutation Create($domain: String!, $sectionName: String!, $panelSectionType: Int!, $systemId: Int!, $section: [CreateLocation!]!) {
    section {
      create(domain: $domain, sectionName: $sectionName, panelSectionType: $panelSectionType, systemId: $systemId, section: $section) {
        code
        success
        message
        updatedValues
      }
    }
  }
`

export interface CreatePanelLocation {
  location_name: string;
  visual: string;
  terminals: {device_id: number, terminal_type?: number | null, config?: Omit<TerminalTypesInfo, "input">, port: number}[]
}

export interface CreatePanelLocationResponse {
  section: {
    create: {
      code: string;
      success: boolean;
      message: string;
      updatedValues?: number[];
    }
  }
}